require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./authors-kate-gulliver.json") })
        }
      }, "path---authors-kate-gulliver");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---authors-kate-gulliver!./.cache/json/authors-kate-gulliver.json
// module id = 1301
// module chunks = 231608221292675